import { DropdownSelect } from './DropdownSelect';

// TODO: in v9, move styled() from DropdownSelect.jsx to here
export var StyledDropdownSelect = DropdownSelect;